module.exports = __webpack_public_path__ + "img/PU.5ca44fcc.png";